export const ERROR = {
  EmailExisted: "Email đã được sử dụng"
};
